<template>
  <div>
    <h3 class="mb-5">Job Information</h3>
    <div class="h4 mb-5">顯示於Carrer Page頁面</div>
    <div>
      <!-- Title -->
      <label class="form-item d-flex pt-5">
        <h4 class="w-180px">Title</h4>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="career.job.title"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- SubTitle -->
      <label class="form-item d-flex pt-5">
        <h4 class="w-180px">SubTitle</h4>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="career.job.subtitle"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- Call To Action -->
      <label class="form-item d-flex pt-5">
        <h4 class="w-180px">Call To Action</h4>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="career.job.call_to_action"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- 導連網址 -->
      <label class="form-item d-flex pt-5 mx-30px">
        <h4 class="w-180px">導連網址</h4>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="career.job.url"
            prepend-inner-icon="mdi-link"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    career: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style></style>
